export const github_copilotModels = {
    id: "github-copilot",
    name: "GitHub Copilot",
    api: "https://api.githubcopilot.com",
    npm: "@ai-sdk/openai-compatible",
    doc: "https://docs.github.com/en/copilot",
    env: ["GITHUB_TOKEN"],
    models: {
        "gemini-2.5-pro": {
            id: "gemini-2.5-pro",
            name: "Gemini 2.5 Pro",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2025-01",
            release_date: "2025-03-20",
            last_updated: "2025-06-05",
            modalities: {
                input: ["text", "image", "audio", "video"],
                output: ["text"],
            },
            open_weights: false,
            limit: {
                context: 128000,
                output: 64000,
            },
        },
        "claude-sonnet-4": {
            id: "claude-sonnet-4",
            name: "Claude Sonnet 4",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-03-31",
            release_date: "2025-05-22",
            last_updated: "2025-05-22",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            limit: {
                context: 128000,
                output: 16000,
            },
        },
        "gpt-4.1": {
            id: "gpt-4.1",
            name: "GPT-4.1",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-04",
            release_date: "2025-04-14",
            last_updated: "2025-04-14",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            limit: {
                context: 128000,
                output: 16384,
            },
        },
        "gemini-2.0-flash-001": {
            id: "gemini-2.0-flash-001",
            name: "Gemini 2.0 Flash",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-06",
            release_date: "2024-12-11",
            last_updated: "2024-12-11",
            modalities: {
                input: ["text", "image", "audio", "video"],
                output: ["text"],
            },
            open_weights: false,
            limit: {
                context: 1000000,
                output: 8192,
            },
        },
        "claude-opus-4": {
            id: "claude-opus-4",
            name: "Claude Opus 4",
            attachment: true,
            reasoning: true,
            temperature: false,
            tool_call: false,
            knowledge: "2025-03-31",
            release_date: "2025-05-22",
            last_updated: "2025-05-22",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            limit: {
                context: 80000,
                output: 16000,
            },
        },
        "grok-code-fast-1": {
            id: "grok-code-fast-1",
            name: "Grok Code Fast 1",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-08",
            release_date: "2025-08-27",
            last_updated: "2025-08-27",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            limit: {
                context: 256000,
                output: 10000,
            },
        },
        "claude-opus-41": {
            id: "claude-opus-41",
            name: "Claude Opus 4.1",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: false,
            knowledge: "2025-03-31",
            release_date: "2025-08-05",
            last_updated: "2025-08-05",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            limit: {
                context: 80000,
                output: 16000,
            },
        },
        "claude-3.7-sonnet-thought": {
            id: "claude-3.7-sonnet-thought",
            name: "Claude Sonnet 3.7 Thinking",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-04",
            release_date: "2025-02-19",
            last_updated: "2025-02-19",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            limit: {
                context: 200000,
                output: 16384,
            },
        },
        "gpt-5": {
            id: "gpt-5",
            name: "GPT-5",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-10",
            release_date: "2025-08-07",
            last_updated: "2025-08-07",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            limit: {
                context: 128000,
                output: 64000,
            },
        },
        o3: {
            id: "o3",
            name: "o3 (Preview)",
            attachment: true,
            reasoning: true,
            temperature: false,
            tool_call: true,
            knowledge: "2024-05",
            release_date: "2025-04-16",
            last_updated: "2025-04-16",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            limit: {
                context: 128000,
                output: 16384,
            },
        },
        "gpt-5-mini": {
            id: "gpt-5-mini",
            name: "GPT-5-mini",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2024-06",
            release_date: "2025-08-13",
            last_updated: "2025-08-13",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            limit: {
                context: 128000,
                output: 64000,
            },
        },
        "claude-3.7-sonnet": {
            id: "claude-3.7-sonnet",
            name: "Claude Sonnet 3.7",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-04",
            release_date: "2025-02-19",
            last_updated: "2025-02-19",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            limit: {
                context: 200000,
                output: 16384,
            },
        },
        "claude-3.5-sonnet": {
            id: "claude-3.5-sonnet",
            name: "Claude Sonnet 3.5",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2024-04",
            release_date: "2024-10-22",
            last_updated: "2024-10-22",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            limit: {
                context: 90000,
                output: 8192,
            },
        },
        "gpt-4o": {
            id: "gpt-4o",
            name: "GPT-4o",
            attachment: true,
            reasoning: false,
            temperature: true,
            tool_call: true,
            knowledge: "2023-09",
            release_date: "2024-05-13",
            last_updated: "2024-05-13",
            modalities: {
                input: ["text", "image"],
                output: ["text"],
            },
            open_weights: false,
            limit: {
                context: 128000,
                output: 16384,
            },
        },
        "o4-mini": {
            id: "o4-mini",
            name: "o4-mini (Preview)",
            attachment: false,
            reasoning: true,
            temperature: false,
            tool_call: false,
            knowledge: "2024-10",
            release_date: "2025-04-16",
            last_updated: "2025-04-16",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            limit: {
                context: 128000,
                output: 65536,
            },
        },
        "o3-mini": {
            id: "o3-mini",
            name: "o3-mini",
            attachment: false,
            reasoning: true,
            temperature: false,
            tool_call: false,
            knowledge: "2024-10",
            release_date: "2024-12-20",
            last_updated: "2025-01-29",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: false,
            limit: {
                context: 128000,
                output: 65536,
            },
        },
    },
};
export default github_copilotModels;
//# sourceMappingURL=github-copilot.js.map